/* eslint-disable react-hooks/exhaustive-deps */

import React, { createContext, useState, useEffect, useContext } from "react";
import { auth } from "../services/firebase"; // Import your Firebase auth instance
import { onAuthStateChanged } from "firebase/auth";

// Create a Context
const UserContext = createContext();

// Create a Provider Component
export const UserProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [userId, setUserId] = useState(null);
  const [isAuthLoading, setIsAuthLoading] = useState(true);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (currentUser) => {
      if (currentUser) {
        setUser(currentUser);
        setUserId(currentUser.uid);
        // console.log("User signed in:", currentUser);
      } else {
        setUser(null);
        setUserId(null);
        // console.log("User signed out");
      }
      setIsAuthLoading(false);
    });

    return () => unsubscribe(); // Cleanup subscription on unmount
  }, []);

  return (
    <UserContext.Provider value={{ user, userId, isAuthLoading }}>
      {children}
    </UserContext.Provider>
  );
};

// Custom Hook to Use Context
export const useUserContext = () => {
  return useContext(UserContext);
};
